import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

type Props = {
  fromCount: number;
  toCount: number;
  removedLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ReduceApplianceCountDialog({
  fromCount,
  toCount,
  removedLabel,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <Modal isOpen toggle={onCancel} centered>
      <ModalHeader toggle={onCancel}>
        Passer de {fromCount} à {toCount} appareil{toCount > 1 ? "s" : ""} ?
      </ModalHeader>
      <ModalBody>
        <p>
          Les informations et les photos déjà saisies pour {removedLabel} seront supprimées de
          cette attestation.
        </p>
        <p style={{color: "#6b6f80", fontSize: "13px", marginBottom: 0}}>
          {toCount > 1
            ? `Les appareils 1 à ${toCount} sont conservés.`
            : "L'appareil 1 est conservé."}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          Annuler
        </Button>
        <Button color="danger" onClick={onConfirm}>
          Supprimer {removedLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
